import log from "./log";

export default (jsonStr, def = null) => {
  if (!jsonStr) return def;

  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    log.error(e);
    return def;
  }
}
